import { TravellerFieldEnum } from '@websky/graphql';
import { validateDate } from '../../../Passenger/utils';
import { convertGenderToCorrectValue } from '../../../utils';
export const checkValue = (allValues, name, value) => {
    if (name === 'gender') {
        return convertGenderToCorrectValue(allValues[name]) === convertGenderToCorrectValue(value);
    }
    return allValues[name] === value;
};
export const isSubsidyValidForPassenger = (passengerValues, subsidy, ignoreFields = []) => {
    return subsidy.validation
        .filter(validation => {
        if (!ignoreFields.length) {
            return true;
        }
        return !ignoreFields.includes(validation.type);
    })
        .every(validation => {
        const value = passengerValues[validation.name];
        const validationResult = validation.validationRules.some(rules => {
            var _a, _b, _c;
            if ((_a = rules.with) === null || _a === void 0 ? void 0 : _a.every(cond => checkValue(passengerValues, cond.name, cond.value))) {
                if (validation.type === TravellerFieldEnum.BirthDate) {
                    if (!value) {
                        return false;
                    }
                    return typeof validateDate(value, rules) !== 'string';
                }
                if ((_b = rules.options) === null || _b === void 0 ? void 0 : _b.length) {
                    return rules.options.some(option => checkValue(passengerValues, validation.name, option.value));
                }
            }
            if ((_c = rules.options) === null || _c === void 0 ? void 0 : _c.length) {
                return rules.options.some(option => checkValue(passengerValues, validation.name, option.value));
            }
            return false;
        });
        return validationResult;
    });
};
